import cssVars from 'css-vars-ponyfill';
import Swal from 'sweetalert2';
import confettiModule from "canvas-confetti";

const confetti = require('canvas-confetti');
window.Swal = Swal;

require('./alpinejs/alpine');
import './multi/add-to-cart.js';
import './multi/banner-mobile.js';
import './multi/btn-mobile-anim.js';
import './multi/clear-cookies.js';
import './multi/fix-100vh.js';
import './multi/pizza-to-favorite.js';
import './multi/sliders.js';
import './multi/updateCard.js';

cssVars({
    rootElement: document
});

console.info('%c Made with 🍕 by Akawam ', `background-color:#f0f0f0;
    color:#f05b33;
    padding:5px 3px 5px 3px;
    font-size: 16px;
    font-weight: 600;
    border: 3px solid #f05b33;
    border-radius: 7px;
    margin: 10px`);

/* import 'select2';
import 'select2/dist/css/select2.css';
import "pikaday/css/pikaday.css";
var Pikaday = require('pikaday'); */
//window.$ = $;
window.confetti = confettiModule;